import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectActionComponent } from './select-action/select-action.component';
import { SelectLightComponent } from './select-light/select-light.component';
import { SelectParametersComponent } from './select-parameters/select-parameters.component';
import { SelectButtonComponent } from './select-button/select-button.component';
import { LightTriggerComponent } from './light-trigger/light-trigger.component';
import { SelectLightInteractionComponent } from './select-light-interaction/select-light-interaction.component';
import { LightActionComponent } from './light-action/light-action.component';
import { LightSceneListComponent } from './light-scene-list/light-scene-list.component';
import { LightSceneCommandComponent } from './light-scene-command/light-scene-command.component';
import { LightActionTypeComponent } from './light-action-type/light-action-type.component';

export const QUICKSTART_TRIGGERS_LIGHTS_ROUTES: Routes = [{
  path: 'lights', children: [{
    path: '', redirectTo: 'select', pathMatch: 'full'
  }, {
    path: 'select', component: LightTriggerComponent
  }, {
    path: 'light/:id', children: [{
      path: '', redirectTo: 'buttons', pathMatch: 'full'
    }, {
      path: 'buttons', children: [{
        path: '', redirectTo: 'select', pathMatch: 'full'
      }, {
        path: 'select', component: SelectButtonComponent,
      }, {
        path: ':button', children: [{
          path: '', component: SelectLightInteractionComponent
        }]
      }]
    }]
  }]
}];

export const QUICKSTART_ACTIONS_LIGHTS_ROUTES: Routes = [{
  path: 'lights', children: [{
    path: '', redirectTo: 'select', pathMatch: 'full'
  }, {
    path: 'select', component: LightActionTypeComponent, children: [{
      path: '', redirectTo: 'light', pathMatch: 'full'
    }, {
      path: 'light', component: LightActionComponent
    }, {
      path: 'scene', component: LightSceneListComponent
    }]
  }, {
    path: 'light/:id', component: SelectActionComponent
  }, {
    path: 'light/:id/:command', component: SelectParametersComponent
  }, {
    path: 'scene/:id', component: LightSceneCommandComponent
  }]
}];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/quickstart-lights.routes.ts